import { render, staticRenderFns } from "./FullSidebar.vue?vue&type=template&id=0420e56e&scoped=true"
import script from "./FullSidebar.vue?vue&type=script&lang=ts"
export * from "./FullSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0420e56e",
  null
  
)

export default component.exports